module.exports = __webpack_public_path__ + "assets/alert-triangle-outlined-8b32a9.svg";